import { useContext, useEffect, useState } from 'react';
import { addSocketHandler, apiClient, hasOnlineUsersPageRole, removeSocketHandler } from '../../utils';
import { Badge, Modal, Table, Tooltip, Typography } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { UserContext } from '../contexts';
import moment from 'moment';

export function OnlineUsers() {
  const [ready, setReady] = useState(false);
  const [count, setCount] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);

  const { user } = useContext(UserContext);
  const canSeeList = hasOnlineUsersPageRole(user);

  useEffect(() => {
    if (!user) {
      return;
    }

    apiClient
      .get('online-users/count')
      .then((response: any) => {
        setCount(response.data);
        setReady(true);
      })
      .catch(() => {});
  }, [user]);

  useEffect(() => {
    addSocketHandler('online-user-count', 'layout-header', (data: any) => {
      setCount(data.count);
    });

    return () => {
      removeSocketHandler('online-user-count', 'layout-header');
    };
  });

  const onClick = () => {
    setModalOpen(true);
  };

  if (!user) {
    return null;
  }

  if (!ready) {
    return (
      <Badge
        count={<span style={{ color: '#52c41a', fontWeight: 700 }}>...</span>}
        style={{ backgroundColor: '#fff', color: '#52c41a', border: '1px solid #52c41a', boxShadow: '0 0 2px #0003' }}
      >
        <UserOutlined style={{ fontSize: 20, color: '#fff' }} />
      </Badge>
    );
  }

  return (
    <>
      <div onClick={canSeeList ? onClick : undefined} style={{ cursor: canSeeList ? 'pointer' : 'inherit' }}>
        <Tooltip destroyTooltipOnHide title={`Çevrimiçi kullanıcılar: ${count}`}>
          <Badge
            count={count}
            style={{ backgroundColor: '#fff', color: '#52c41a', border: '1px solid #52c41a', boxShadow: '0 0 2px #0003' }}
            overflowCount={99}
          >
            <UserOutlined style={{ fontSize: 20, paddingRight: '0.25rem', color: '#fff' }} />
          </Badge>
        </Tooltip>
      </div>
      <Modal
        title="Çevrimiçi kullanıcılar"
        width="50%"
        visible={modalOpen}
        onCancel={() => {
          setModalOpen(false);
        }}
        footer={null}
      >
        <OnlineUsersList />
      </Modal>
    </>
  );
}

function OnlineUsersList() {
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState<any[]>();

  const { Link } = Typography;

  const loadUsers = () => {
    setLoading(true);
    apiClient
      .get('online-users')
      .then((response: any) => {
        setUsers(response.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    loadUsers();
  }, []);

  useEffect(() => {
    addSocketHandler('online-user-count', 'online-users-modal', () => {
      loadUsers();
    });

    return () => {
      removeSocketHandler('online-user-count', 'online-users-modal');
    };
  });

  const tableColumns = [
    {
      title: 'İsim',
      dataIndex: 'fullName',
      key: 'fullName',
    },
    {
      title: 'E-posta',
      dataIndex: 'email',
      key: 'email',
      render: (email: string) => <Link href={'mailto:' + email}>{email}</Link>,
    },
    {
      title: 'Bölüm',
      dataIndex: 'department',
      key: 'department',
    },
    {
      title: 'Ünvan',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Çevrimiçi zamanı',
      dataIndex: 'onlineSince',
      key: 'onlineSince',
      render: (onlineSince: string) => moment(onlineSince).format('DD.MM.yyyy HH:mm:ss'),
    },
  ];

  return <Table columns={tableColumns} dataSource={users} loading={loading} pagination={false} />;
}
